import { Grid, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";
import { capitaliseFirstLetter } from "../../utils/StringsAdapter";


import { TemperatureContainer } from "../FirstStepContainer/TemperatureBox/styles";

interface MonthSelectorProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  temperatureData: Record<number, number>;
  required?: boolean;
}

const months = [
  { key: "jan", name: "jan", number: 1 },
  { key: "feb", name: "feb", number: 2 },
  { key: "mar", name: "mar", number: 3 },
  { key: "apr", name: "apr", number: 4 },
  { key: "may", name: "may", number: 5 },
  { key: "jun", name: "jun", number: 6 },
  { key: "jul", name: "jul", number: 7 },
  { key: "aug", name: "aug", number: 8 },
  { key: "sep", name: "sep", number: 9 },
  { key: "oct", name: "oct", number: 10 },
  { key: "nov", name: "nov", number: 11 },
  { key: "dec", name: "dec", number: 12 },
];

export const FormMonthSelector = <T extends FieldValues>({
  name,
  control,
  temperatureData,
  required = false,
}: MonthSelectorProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const value = (field.value || []) as string[];

        const handleToggleMonth = (monthKey: string) => {
          const isSelected = value.includes(monthKey);
          let newValue: string[];

          if (isSelected) {
            
            newValue = value.filter((month) => month !== monthKey);
          } else {
            
            newValue = [...value, monthKey];
          }

          field.onChange(newValue);
        };

        return (
          <>
            <Grid
              container
              direction="row"
              justifyContent="center"
              flexDirection="row"
              gap={1}
            >
              {months.map((month, index) => {
                const isSelected = value.includes(month.key);
                const temperature = temperatureData[month.number] || 0;

                return (
                  <TemperatureContainer
                    key={month.key}
                    highlighted={isSelected}
                    item
                    md={0.9}
                    onClick={() => handleToggleMonth(month.key)}
                  >
                    <Typography>{capitaliseFirstLetter(month.name)}</Typography>
                    <Typography>{temperature}°C</Typography>
                    {isSelected ? (
                      <CheckIcon color="success" />
                    ) : (
                      <CloseIcon color="error" />
                    )}
                  </TemperatureContainer>
                );
              })}
            </Grid>
            {error && (
              <Typography color="error" variant="caption">
                {error.message}
              </Typography>
            )}
          </>
        );
      }}
    />
  );
};
